import { createStyles } from '@mantine/core'

export default createStyles((theme, _params) => {
  return {}
})
